/******/ (() => { // webpackBootstrap
/******/ 	"use strict";
/******/ 	// The require scope
/******/ 	var __webpack_require__ = {};
/******/ 	
/************************************************************************/
/******/ 	/* webpack/runtime/define property getters */
/******/ 	(() => {
/******/ 		// define getter functions for harmony exports
/******/ 		__webpack_require__.d = (exports, definition) => {
/******/ 			for(var key in definition) {
/******/ 				if(__webpack_require__.o(definition, key) && !__webpack_require__.o(exports, key)) {
/******/ 					Object.defineProperty(exports, key, { enumerable: true, get: definition[key] });
/******/ 				}
/******/ 			}
/******/ 		};
/******/ 	})();
/******/ 	
/******/ 	/* webpack/runtime/hasOwnProperty shorthand */
/******/ 	(() => {
/******/ 		__webpack_require__.o = (obj, prop) => (Object.prototype.hasOwnProperty.call(obj, prop))
/******/ 	})();
/******/ 	
/******/ 	/* webpack/runtime/make namespace object */
/******/ 	(() => {
/******/ 		// define __esModule on exports
/******/ 		__webpack_require__.r = (exports) => {
/******/ 			if(typeof Symbol !== 'undefined' && Symbol.toStringTag) {
/******/ 				Object.defineProperty(exports, Symbol.toStringTag, { value: 'Module' });
/******/ 			}
/******/ 			Object.defineProperty(exports, '__esModule', { value: true });
/******/ 		};
/******/ 	})();
/******/ 	
/************************************************************************/
var __webpack_exports__ = {};
/*!***********************************************************!*\
  !*** ./resources/scripts/sections/content-blocks/main.js ***!
  \***********************************************************/
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "contentBlock": () => (/* binding */ contentBlock),
/* harmony export */   "default": () => (__WEBPACK_DEFAULT_EXPORT__)
/* harmony export */ });
var contentBlock = function contentBlock() {
  var containers = document.querySelectorAll(".svg-container");

  // if (containers) {
  //     containers.forEach((container) => {
  //         const svgElement = container.querySelector('#floating-svg');
  //         let targetX = 0,
  //             targetY = 0;
  //         let currentX = 0,
  //             currentY = 0;
  //         const delay = 0.1;

  //         function updateContainerBounds() {
  //             const bounds = container.getBoundingClientRect();
  //             return {
  //                 top: bounds.top + window.scrollY,
  //                 left: bounds.left + window.scrollX,
  //                 bottom: bounds.bottom + window.scrollY,
  //                 right: bounds.right + window.scrollX,
  //                 width: bounds.width,
  //                 height: bounds.height,
  //             };
  //         }

  //         function handleMove(event) {
  //             const bounds = updateContainerBounds();
  //             const mouseX =
  //                 event.type === 'mousemove'
  //                     ? event.clientX + window.scrollX
  //                     : event.touches[0].clientX + window.scrollX;
  //             const mouseY =
  //                 event.type === 'mousemove'
  //                     ? event.clientY + window.scrollY
  //                     : event.touches[0].clientY + window.scrollY;

  //             // Center the SVG on the cursor, but keep it within the container
  //             targetX = Math.min(
  //                 Math.max(mouseX - svgElement.offsetWidth / 2, bounds.left),
  //                 bounds.right - svgElement.offsetWidth
  //             );

  //             targetY = Math.min(
  //                 Math.max(mouseY - svgElement.offsetHeight / 2, bounds.top),
  //                 bounds.bottom - svgElement.offsetHeight
  //             );
  //         }

  //         function animate() {
  //             currentX += (targetX - currentX) * delay;
  //             currentY += (targetY - currentY) * delay;

  //             svgElement.style.transform = `translate(${currentX}px, ${currentY}px)`;

  //             requestAnimationFrame(animate);
  //         }

  //         document.addEventListener('mousemove', handleMove);
  //         document.addEventListener('touchmove', handleMove, { passive: true });

  //         animate();
  //     });
  // }
};

/* harmony default export */ const __WEBPACK_DEFAULT_EXPORT__ = (contentBlock);
document.addEventListener("DOMContentLoaded", contentBlock);
/******/ })()
;